import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * PinkCTA — full-width hot-pink color block used to close every page
 * (except Home, which already has the pink Testimonials section).
 * Creates visual rhythm between the dark page content and the dark footer.
 */
const PinkCTA = () => {
  const location = useLocation();
  if (location.pathname === "/") return null; // Home has its own pink block

  const handleClick = (e) => {
    if (location.pathname === "/contact") {
      e.preventDefault();
      const formEl = document.getElementById("contact-form");
      if (formEl) formEl.scrollIntoView({ behavior: "smooth", block: "start" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section
      className="bg-[#F62493] text-white py-20 md:py-28"
      data-testid="pink-cta-banner"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <p className="font-mono-label text-white/80 mb-4">Let&apos;s make something great</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] text-white">
            Have a brand, launch, or campaign that deserves <em className="italic">more than ordinary?</em>
          </h2>
        </div>
        <div className="md:col-span-4 flex md:justify-end">
          <Link
            to="/contact#contact-form"
            onClick={handleClick}
            data-testid="pink-cta-button"
            className="inline-flex items-center gap-2 rounded-full border-2 border-white text-white px-7 py-3.5 hover:bg-white hover:text-[#F62493] transition-colors font-mono-label"
          >
            Start a project <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PinkCTA;
